import { LOGIN_SUCCESS, SAVE_LOGGED_IN_USER } from "../types";

const INITIAL_STATE = {
    token: null,
    isLoggedIn: false,
    loggedInUser: null,
};

const authReducer = (state = INITIAL_STATE, { type, payload }) => {
    switch (type) {
        case LOGIN_SUCCESS:
            return {
                ...state,
                token: payload,
            };
        case SAVE_LOGGED_IN_USER:
            return {
                ...state,
                loggedInUser: payload,
            };
        default:
            return state;
    }
};

export default authReducer;
